import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'react-bootstrap'
import { Typography, FullPageContainer, ScrollableContainer } from '../styled'
import theme from '../../constants/theme'
import FullLogo from '../../assets/logos/full-logo.png'
import LanguagesDropdown from '../languageDropdown'
import UserOutline from '../../assets/svgs/UserOutline'
import ClockOutline from '../../assets/svgs/ClockOutline'
import ClipboardOutline from '../../assets/svgs/ClipboardOutline'
import ArrowRight from '../../assets/svgs/ArrowRight'
import { getAssessmentTypeLabel } from './helpers'
import {
  StickyHeader,
  IntroCenter,
  AssessmentCard,
  DecorCircle,
  CardInner,
  TypeBadge,
  IntroDescription,
  StatBox,
  StatIcon,
  StartButton,
} from './styles'

function IntroScreen({ assessment, onStart }) {
  const { t } = useTranslation()

  return (
    <FullPageContainer>
      <StickyHeader>
        <Col xs="auto">
          <img height="auto" width="150px" src={FullLogo} alt="" />
        </Col>
        <Col />
        <Col xs="auto" className="mt-3">
          <LanguagesDropdown />
        </Col>
      </StickyHeader>
      <ScrollableContainer className="fw-light">
        <IntroCenter>
          <Row className="justify-content-center w-100">
            <Col xs={12} md={7} lg={5}>
              <AssessmentCard className="shadow-sm border-0">
                {/* decorative corner circles */}
                <DecorCircle size={180} offset={70} />
                <DecorCircle size={120} offset={40} />

                <CardInner>
                  <TypeBadge className="mb-3">
                    <UserOutline width={14} height={14} />
                    {getAssessmentTypeLabel(t, assessment?.assessmentType)}
                  </TypeBadge>

                  <Typography
                    bold
                    size="26px"
                    color={theme.talentinoBlack}
                    className="mb-2 d-block"
                  >
                    {assessment?.name}
                  </Typography>

                  {assessment?.description ? (
                    <IntroDescription
                      className="mb-4"
                      dangerouslySetInnerHTML={{
                        __html: assessment.description,
                      }}
                    />
                  ) : (
                    <Typography
                      size="14px"
                      color={theme.talentinoSecondaryGray}
                      className="mb-4 d-block"
                    >
                      {t('assessment.introInstructions')}
                    </Typography>
                  )}

                  <Row className="mb-4 g-3">
                    <Col xs={6}>
                      <StatBox>
                        <StatIcon>
                          <ClockOutline width={18} height={18} />
                        </StatIcon>
                        <div className="d-flex flex-column">
                          <Typography
                            bold
                            size="16px"
                            color={theme.talentinoBlack}
                          >
                            {assessment?.durationMinutes} {t('assessment.min')}
                          </Typography>{' '}
                          <Typography
                            size="10px"
                            color={theme.talentinoSecondaryGray}
                          >
                            {t('assessment.duration')}
                          </Typography>
                        </div>
                      </StatBox>
                    </Col>
                    <Col xs={6}>
                      <StatBox>
                        <StatIcon>
                          <ClipboardOutline width={18} height={18} />
                        </StatIcon>
                        <div className="d-flex flex-column">
                          <Typography
                            bold
                            size="16px"
                            color={theme.talentinoBlack}
                          >
                            {assessment?.questions?.length || 0}
                          </Typography>
                          <Typography
                            size="10px"
                            color={theme.talentinoSecondaryGray}
                          >
                            {t('interview.questions')}
                          </Typography>
                        </div>
                      </StatBox>
                    </Col>
                  </Row>

                  <StartButton width="100%" height="52px" onClick={onStart}>
                    {t('assessment.startAssessment')}
                    <ArrowRight width={16} height={16} />
                  </StartButton>
                </CardInner>
              </AssessmentCard>
            </Col>
          </Row>
        </IntroCenter>
      </ScrollableContainer>
    </FullPageContainer>
  )
}

IntroScreen.propTypes = {
  assessment: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    assessmentType: PropTypes.string,
    durationMinutes: PropTypes.number,
    questions: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  onStart: PropTypes.func.isRequired,
}

export default IntroScreen
